(function (angular, schoolwork12) {
    
    'use strict';
    angular.module(schoolwork12.app.student.name)

    .factory(schoolwork12.app.student.services.studentLockCurriculum, 
        ['$rootScope', '$http', '$uibModal', '$q', schoolwork12.app.auth.services.authentication,
        function($rootScope, $http, $uibModal, $q, authentication) {      

  		var service  = function lockCurriculumModal(selectedStudents, selectedStudentsCount) {
			var modalInstance = $uibModal.open({
			    templateUrl: schoolwork12.app.student.templates.studentLockCurriculum,
			    size: 'md',
			    backdrop: 'static',
			    windowClass: 'medium-Modal',
			    controller: ['$scope', '$uibModalInstance',			   
		        function ($scope, $uibModalInstance) {
		       		console.log("Viewing Lock Curriculum for Students");
				
			    //initialize default settings
			    $scope.LockCurriculumErrorMesg = "";
			    $scope.LockCurriculumErrorOccurred = false;
			    $scope.LockCurriculumErrorAuthorizedByMesg = "";
			    $scope.LockCurriculumErrorAuthorizedBy = false;
			    $scope.LockCurriculumErrorReasonMesg = "";
			    $scope.LockCurriculumErrorReason = false;
			    $scope.LockCurriculumErrorCommentsMesg = "";
			    $scope.LockCurriculumErrorComments = false;
			    $scope.loadingLockCurriculumErrorOccurred = false;
			    $scope.isSaveStudentLockCurriculumBusy = false;			    
				$scope.studentsCount = selectedStudentsCount;
				$scope.lockCurriculum = {};
				$scope.LockCurriculumForm = false;
				$scope.LockCurriculumButtonAction = true;

			   $http({
		            //get a list of Reasons to lock a curriculum
		            url : schoolwork12.app.student.endpoints.lockCurriculumReason,
		            method : 'GET',		            
	        		headers : {
								'X-API-TOKEN' : authentication.getCurrentUser().keycode,
							  }
	            }).success(function (response) {
            	    $scope.lockCurriculumReasonList = response;  
            	    
	            }).error(function(error){
	                console.info('Error in retrieving lock curriculum reasons...'.concat(angular.toJson(error)));
	                $scope.LockCurriculumButtonAction = false;
	                $scope.loadingLockCurriculumErrorOccurred = true;
	                $scope.lockStudentsLoadingErrorMesg = schoolwork12.app.errorMessages.internalError

                	if (error.status == 400) {
						for ( var j = 0; j < error.data._errors.length; j++) {
							$scope.lockStudentsLoadingErrorMesg = $scope.lockStudentsLoadingErrorMesg + error.data._errors[j] + "\n";
						}
					} else if (error.status == 401 || error.status == 403) {
                        $scope.lockStudentsLoadingErrorMesg = $scope.lockStudentsLoadingErrorMesg + 
                        									schoolwork12.app.errorMessages.sessionExpired;
                    } 
                      
	            });

				$scope.cancel = function () {
				    $uibModalInstance.dismiss('cancel');
				};

				$scope.closeErrorMsg = function() {
                    $scope.LockCurriculumErrorOccurred = false;
                }  

				$scope.studentLockCurriculum = function(){
					resetErrorFlags();
					$scope.isSaveStudentLockCurriculumBusy = true;

                    if ($scope.isFormValid()) {
                    	$scope.LockCurriculumForm = true;

                    	$http({
			              	url : schoolwork12.app.student.endpoints.studentCurriculumLock,
			              	method : "POST",
			              	data : {
								    reasonId: $scope.lockCurriculum.reason,
								    authorizedBy: $scope.lockCurriculum.authorizedBy,
								    otherReason: $scope.lockCurriculum.comments,
								    students:selectedStudents
									},
		        		  	headers : {
										'X-API-TOKEN' : authentication.getCurrentUser().keycode,
									}
			              	}).success(function (response) {
			              		console.info("Students locked successfully", response);
	            	   			$scope.LockCurriculumErrorOccurred = false;
	            	   			$rootScope.actionCompletedSuccessfully = true;
	            	   			$rootScope.actionCompletedSuccessfullyMessage = "You have successfully locked your student(s)'s curriculum."
			              		$uibModalInstance.close();
			              	}).error(function(error, status){ 
			              		$scope.LockCurriculumErrorOccurred = true;
			              		$scope.LockCurriculumButtonAction = false;
			                	console.info('Error in locking students...'.concat(angular.toJson(error)));
			                	if (status == 400) {
									for ( var j = 0; j < error.data._errors.length; j++) {
										$scope.LockCurriculumErrorMesg = schoolwork12.app.student.modalErrMessages.lockStudentsFailed + error.data._errors[j] + "\n";
									}
								} else if (status == 401 || status == 403) {
			                        $scope.LockCurriculumErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
			                    } else {
			                        $scope.LockCurriculumErrorMesg = schoolwork12.app.student.modalErrMessages.lockStudentsFailed + " " + schoolwork12.app.errorMessages.internalError;
			                    }
			            	});

                    } else {
                    	$scope.isSaveStudentLockCurriculumBusy = false;
                    	$scope.LockCurriculumForm = false;
                    }
				}

				$scope.isFormValid = function(){

					console.info("Validating lockCurriculum authorizedBy");
					if ($scope.lockCurriculum.authorizedBy == null ||
					    $scope.lockCurriculum.authorizedBy== "") {
						$scope.LockCurriculumErrorAuthorizedBy = true;
						$scope.LockCurriculumErrorAuthorizedByMesg = schoolwork12.app.student.errorMessages.authorizedByRequired;
					}

					console.info("Validating lockCurriculum Reason");
					if ($scope.lockCurriculum.reason == null ||
					    $scope.lockCurriculum.reason== "") {
						$scope.LockCurriculumErrorReason = true;
						$scope.LockCurriculumErrorReasonMesg = schoolwork12.app.student.errorMessages.reasonRequired;
					}

					console.info("Validating lockCurriculum comment");
					if ($scope.lockCurriculum.comments == null ||
					    $scope.lockCurriculum.comments== "") {
						$scope.LockCurriculumErrorComments = true;
						$scope.LockCurriculumErrorCommentsMesg = schoolwork12.app.student.errorMessages.commentRequired 
						
					}

					return !$scope.LockCurriculumErrorAuthorizedBy && !$scope.LockCurriculumErrorComments && !$scope.LockCurriculumErrorReason

				}

				
                           	
				var resetErrorFlags = function() {
                    // Control Error messages 
                    $scope.LockCurriculumErrorMesg = "";
                    $scope.LockCurriculumErrorOccurred = false; 
                    $scope.LockCurriculumErrorCommentsMesg = "";
                    $scope.LockCurriculumErrorComments = false;                    
                    $scope.LockCurriculumErrorReasonMesg = "";
                    $scope.LockCurriculumErrorReason = false;     
                    $scope.LockCurriculumErrorAuthorizedByMesg = "";
                    $scope.LockCurriculumErrorAuthorizedBy = false;    
                    $rootScope.actionCompletedSuccessfully = false;
	            	$rootScope.actionCompletedSuccessfullyMessage = ""
                }

			}],
		  	    
		});

	};

    return {
    	service: service
    };

}]);
    
}(angular, schoolwork12));